import { DropdownArrPropsType } from "DataTypes/Form";
import { CheckArr } from "./common";

export const FormatDropdownData: (
  data: any,
  idKey: string,
  labelKey: string,
  valKey: string
) => DropdownArrPropsType[] = (data, idKey, labelKey, valKey) => {
  const newArr = CheckArr(data);
  if (newArr.length > 0) {
    return data?.map((el: any, index: number) => ({
      id: idKey ? el[idKey] : index,
      label: el[labelKey] || "",
      value: el[valKey] || "",
    }));
  } else return []
};

export default {
  FormatDropdownData,
};
